<template>
  <b-modal
    ref="modal"
    v-model="isShown"
    :title="$t('views.file_list.file_delete')"
    modal-class="spso-modal"
    hide-header-close
    hide-footer
    centered
    @hidden="hideModal"
  >
    <div class="spso-modal__body">
      <p class="delete-action-modal__text">
        {{ $t('views.file_list.file_remove_question') }}
        <br>
        {{ $t('views.file_list.file_remove_confirmation') }}
      </p>
    </div>
    <div class="v-application d-flex">
      <v-btn
        class="mr-4 flex-grow-1"
        outlined
        large
        :disabled="loading"
        @click="hideModal"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <v-btn
        color="primary"
        class="flex-grow-1"
        :loading="loading"
        outlined
        large
        @click="submit"
      >
        {{ $t('common.delete') }}
      </v-btn>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'FileRemove',

  model: {
    prop: 'value',
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },

    selectedFile: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      loading: false,
      isShown: false,
    };
  },

  watch: {
    value(val) {
      this.isShown = val;
    },
  },

  methods: {
    hideModal() {
      this.$emit('input', false);
    },

    async submit() {
      this.loading = true;
      try {
        await this.$http.delete(`/files/${this.selectedFile.id}`);
        this.hideModal();
        this.$emit('submit');
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
